// ConditionalRoute.tsx
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface ConditionalRouteProps {
  condition: boolean
  navigateTo: string
  element: JSX.Element
}

const ConditionalRoute: React.FC<ConditionalRouteProps> = ({ condition, navigateTo, element }) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (condition) {
      navigate(navigateTo)
    }
  }, [condition, navigate, navigateTo])

  return element
}

export default ConditionalRoute
